import { render, staticRenderFns } from "./LabelError.vue?vue&type=template&id=2e6d5ae3&"
import script from "./LabelError.vue?vue&type=script&lang=js&"
export * from "./LabelError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports